// extracted by css-extract-rspack-plugin
export default {"legend":"ZLgMumG1L8M9hn8v","entry":"_wmiZ2bacAxg7AZn","swatch":"LvfkGUbpOwYDqtPg"};